/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { Button, Navbar } from 'react-bootstrap';
import styled from 'styled-components';

export const NavBarContainer = styled(Navbar)`
  background-color: #0b2d51;
  position: fixed;
  top: 0;
  width: 100%;
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchContainer = styled.div`
  display: inline-block;
  position: relative;
`;

export const SearchBar = styled.input`
  padding: 10px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) 0px 0px 3px;
  font-size: 12px;
  width: 350px;
  background-color: whitesmoke;
  color: black;
`;

export const SubmitButton: any = styled(Button)`
  background-color: #104382;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 0 5px 5px 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) 0px 0px 3px;
  position: absolute;
  top: 0;
  right: 0;
  transition: 0.9s ease;
  font-size: 12px;

  &:hover {
    transform: scale(1.1);
    color: white;
    background-color: #104382;
  }

  &:focus {
    background-color: #104382;
  }

  &:active {
    transform: translateY(4px);
  }
`;

export const ButtonContainer = styled.div`
  display: grid;
  align-self: flex-end;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  align-items: center;
  justify-content: center;
`;

export const ListEventButton: any = styled(Button)`
  border: 0.8px solid white;
  background-color: transparent;
  color: white;
  font-size: 12px;
  border-radius: 3px;
  transition: background-color 0.15s ease;
  transition: color 0.15s ease;

  &:hover {
    background-color: lightgray;
    color: black;
  }

  &:active {
    transform: translateY(4px);
  }
`;

export const SignInButton: any = styled(Button)`
  background-color: #104382;
  color: white;
  font-size: 12px;
  border-radius: 3px;
  transition: background-color 0.15s ease;
  border: none;

  &:hover {
    background-color: #e15205;
  }

  &:active {
    transform: translateY(4px);
  }

  &:focus {
    background-color: #104382;
  }
`;

// import { Button, Navbar } from 'react-bootstrap';
// import styled from 'styled-components';

// export const NavBarContainer = styled(Navbar)`
//   background-color: #0b2d51;
//   position: fixed;
//   top: 0;
//   width: 100%;
// `;

// export const LeftContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// export const SearchContainer = styled.div`
//   display: inline-block;
//   position: relative;
// `;

// export const SearchBar = styled.input`
//   padding: 10px;
//   border: none;
//   border-radius: 5px;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) 0px 0px 3px;
//   font-size: 12px;
//   width: 350px;
//   background-color: whitesmoke;
//   color: black;
// `;

// export const SubmitButton: any = styled(Button)`
//   background-color: #104382;
//   border: none;
//   color: #fff;
//   cursor: pointer;
//   padding: 10px 20px;
//   border-radius: 0 5px 5px 0;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) 0px 0px 3px;
//   position: absolute;
//   top: 0;
//   right: 0;
//   transition: 0.9s ease;
//   font-size: 12px;

//   &:hover {
//     transform: scale(1.1);
//     color: white;
//     background-color: #104382;
//   }

//   &:focus {
//     background-color: #104382;
//   }

//   &:active {
//     transform: translateY(4px);
//   }
// `;

// export const ButtonContainer = styled.div`
//   display: grid;
//   align-self: flex-end;
//   grid-template-columns: 1fr 1fr;
//   column-gap: 10px;
//   align-items: center;
//   justify-content: center;
// `;

// export const ListEventButton: any = styled(Button)`
//   border: 0.8px solid white;
//   background-color: transparent;
//   color: white;
//   font-size: 12px;
//   border-radius: 3px;
//   transition: background-color 0.15s ease;
//   transition: color 0.15s ease;

//   &:hover {
//     background-color: lightgray;
//     color: black;
//   }

//   &:active {
//     transform: translateY(4px);
//   }
// `;

// export const SignInButton: any = styled(Button)`
//   background-color: #104382;
//   color: white;
//   font-size: 12px;
//   border-radius: 3px;
//   transition: background-color 0.15s ease;
//   border: none;

//   &:hover {
//     background-color: #e15205;
//   }

//   &:active {
//     transform: translateY(4px);
//   }

//   &:focus {
//     background-color: #104382;
//   }
// `;
